import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;
import "./utils/rem.js";

import clipboard from "clipboard";
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
Vue.config.ignoredElements = ["wx-open-launch-app"];
import vConsole from "vconsole";

process.env.NODE_ENV !== "production" ? new vConsole() : "";

new Vue({
	render: (h) => h(App)
}).$mount("#app");
